import { getErrorRes, getSuccessRes } from "../helpers/api-response";
import { handleErrorMessage } from "../helpers/handle-error-message";
import logger from "../helpers/logger";
import axiosIns from "../common/interceptor/axios-interceptor";

//Fetch RackNote data
export const fetchRackNoteData = async () => {
  try {
    const res = await axiosIns.get(`rackstar/racknote`);
    return getSuccessRes(res.data || [], "RackNote data fetched successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch RackNote data.`);
  }
};

//Delete racknote
export const deleteRackNoteData = async (id) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/racknote/${id}`
    );
    return getSuccessRes(res.data || [], "RackNote data deleted successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete RackNote data.`);
  }
};

// Update an existing racknote entry
export const updateRacknoteData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/racknote/${id}`,
      data
    );
    return getSuccessRes(res.data, "RackNote data updated successfully!");
  } catch (error) {
    logger.error("updateRacknoteData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update RackNote Data.");
  }
};

//Add a racknote data
export const addRackNoteData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(`rackstar/racknote`, data);
    return getSuccessRes(res.data, "RackNote data added successfully!");
  } catch (error) {
    logger.error("addRackNoteData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add RackNote data.");
  }
};
